import React from 'react';

const EmailCloudMouth = () => {
  return (
    <svg
      width="129"
      height="74"
      viewBox="0 0 129 74"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 36C26.7332 53.5792 53.7929 62.2474 89 43.3936"
        stroke="black"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M102.824 6.83447C90.2467 14.3212 88.1809 33.597 93.7197 45.1388C100.541 59.3523 116.69 65.4961 123.681 63.4301"
        stroke="black"
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default EmailCloudMouth;
